/* eslint-disable react/display-name */
import React, { useState, useEffect } from 'react';
import { AdminNavbar } from '../layout/PageHeader';
import { AccountTypeContext } from '../dashboard/Dashboard';
import { Row, Col, Button, Table, Tag, Input } from 'antd';
import { getAllUsers, getAds } from '../../store/admin/actions';
import { useDispatch, useSelector } from 'react-redux';
import { getAdminState } from '../../store/admin/selector';
import { UserState } from '../../store/admin/types';
import { useHistory } from 'react-router-dom';
import { colors } from '../../constants/colors';
import { getUserState } from '../../store/user/selector';

const { Column } = Table;

export interface UsersProps {
  users: UserState[];
  logged: any;
}

export const ManageUsers: React.FC<UsersProps> = ({ users, logged }) => {
  const [filteredusers, setFilterUser] = useState<Array<{}>>(users);
  const [newkey, setKey] = useState<string>('all');
  const history = useHistory();
  const handleManageButton = (record: any) => {
    history.push({
      pathname: '/manageuser',
      state: record,
    });
  };
  const handleFilterButton = (key: string) => {
    const allUser = users;
    const activeUser = users.filter(item => item.status[0] === 'active');
    const suspendedUser = users.filter(item => item.status[0] === 'suspended');
    if (key === 'active') {
      setFilterUser(activeUser);
      setKey(key);
    } else if (key === 'suspended') {
      setFilterUser(suspendedUser);
      setKey(key);
    } else {
      setFilterUser(allUser);
      setKey(key);
    }
  };

  const handleSearchUsers = (e: React.FormEvent<HTMLInputElement>) => {
    const matchtext = e.currentTarget.value.toLowerCase();
    const matchusers = users.filter(item =>
      item.name.toLowerCase().match(matchtext)
    );
    setFilterUser(matchusers);
  };
  const checkedUsers = () => {
    setFilterUser(users);
    if (logged.accountType !== 'admin' && logged.authComplete) {
      history.push('profile');
      return;
    }
    if (!logged.authComplete) {
      history.push('/');
      return;
    }
  };

  useEffect(checkedUsers, [users, logged]);
  return (
    <Col xs={24} sm={24} md={24} lg={24} className="manage-user-container">
      <Row justify="space-between" className="header-wrap">
        <span>Manage MyCookAround Users</span>
        <Col className="status-indicator">
          <Button
            className="button-all"
            onClick={() => handleFilterButton('all')}
            style={
              newkey === 'all'
                ? { backgroundColor: colors.blue, color: '#fff' }
                : { color: '#000000' }
            }
          >
            <span
              style={newkey === 'all' ? { color: '#fff' } : { color: '#000' }}
            >
              All
            </span>
          </Button>
          <Button
            className="button-act"
            onClick={() => handleFilterButton('active')}
            style={
              newkey === 'active'
                ? { backgroundColor: colors.green }
                : { color: '#000000' }
            }
          >
            <span
              style={
                newkey === 'active' ? { color: '#fff' } : { color: '#000' }
              }
            >
              Active
            </span>
          </Button>
          <Button
            className="button-sus"
            onClick={() => handleFilterButton('suspended')}
            style={
              newkey === 'suspended'
                ? { backgroundColor: colors.orange }
                : { color: '#000000' }
            }
          >
            <span
              style={
                newkey === 'suspended' ? { color: '#fff' } : { color: '#000' }
              }
            >
              Supended
            </span>
          </Button>
        </Col>
        <div className="table-search-input-container">
          <Input placeholder="Search users" onChange={handleSearchUsers} />
        </div>
      </Row>
      <div className="table-wrap">
        <Table dataSource={filteredusers}>
          <Column title="Name" dataIndex="name" key="name" />
          <Column title="Phone" dataIndex="phone" key="phone" />
          <Column
            title="Type"
            key="accountType"
            render={(record: any) => (
              <div>
                <span>
                  {`${record.accountType} ${
                    record.subAccountType !== ''
                      ? `${
                          record.subAccountType === undefined
                            ? ''
                            : `/ ${record.subAccountType}`
                        }`
                      : ''
                  }`}
                </span>
              </div>
            )}
          />
          <Column
            title="Status"
            dataIndex="status"
            key="status"
            render={(status: any[]) => (
              <>
                {status.map(stat => {
                  let color;
                  if (stat === 'active') {
                    color = '#8dc63f';
                  } else if (stat === 'suspended') {
                    color = '#FF5C5C';
                  }
                  return (
                    <Tag color={color} key={stat}>
                      {stat}
                    </Tag>
                  );
                })}
              </>
            )}
          />
          <Column
            title="Action"
            key="action"
            render={(text, record) => (
              <Row justify="center">
                <Button
                  className="button-manage"
                  onClick={() => handleManageButton(record)}
                >
                  <span>Manage</span>
                </Button>
              </Row>
            )}
          />
        </Table>
      </div>
    </Col>
  );
};

export const Admin: React.FC = () => {
  const [forWho, setForWho] = useState('Admin');
  const { user } = useSelector(getUserState);
  const dispatch = useDispatch();
  const getUsers = () => {
    dispatch(getAllUsers());
    dispatch(getAds());
  };

  const handleAccountTypeChange = () => {
    const tempForWho = forWho;
    setForWho(tempForWho);
  };
  useEffect(getUsers, []);
  const { users } = useSelector(getAdminState);
  return (
    <AccountTypeContext.Provider value={{ forWho, handleAccountTypeChange }}>
      <div className="admin">
        <Row justify="center">
          <AdminNavbar />
        </Row>
        <Row justify="center">
          <ManageUsers users={users} logged={user} />
        </Row>
      </div>
    </AccountTypeContext.Provider>
  );
};
